import makeFetcher from './makeFetcher';

const fetcher = makeFetcher();

/**
 * @template T
 * @typedef   {object}  FetchResponse
 * @property  {number}  status            (Ex: 200)
 * @property  {string}  statusText        (Ex: '')
 * @property  {T}       data
 */

export default fetcher;
